// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__1hmUg","message":"CookieConsent_message__1GQW-","cookieLink":"CookieConsent_cookieLink__2oRdH","continueBtn":"CookieConsent_continueBtn__hNrP8"};